<template>
  <div class="nq5c-zt">
    <div class="fullPage" id="page" ref="fullPage">
      <!-- <div id="fullPageContainer" class="fullPageContainer" ref="fullPageContainer" @mousewheel="mouseWheel"
        @touchstart="getTouchstartY()" @touchend="touchmove()" @touchmove.prevent> -->
      
      <!-- PC端浮动留资 mob端右侧按钮浮动 -->
      <div v-if="false" class="oneform" :class="{ 'animate': isAnimating }">
        <el-form :inline="true">
          <el-form-item class="inbox">
            <el-input class="inboxinput" v-model="formInline.Name" placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item class="inbox">
            <el-input class="inboxinput" v-model="formInline.Phone" placeholder="电话"></el-input>
          </el-form-item>
          <el-form-item class="inbox">
            <el-select class="inboxinput" v-model="formInline.CarSeriesCMSID" placeholder="请选择车型" @change="setCarSeries">
              <el-option v-for="(item, key) in (carAlldata ? carAlldata.series : [])" :key="key" :value="item.cmsid"
                :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="inbox">
            <el-select class="inboxinput" v-model="formInline.Province" placeholder="选择省份" @change="setProvince">
              <el-option v-for="(item, key) in (alldata ? alldata.province : [])" :value="item.id" :key="key"
                :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="inbox">
            <el-select class="inboxinput" v-model="formInline.City" placeholder="选择城市" @click="setCity()"
              code-stm="event, PAGEURL, 切换城市信息pc" @change="cityChange">
              <el-option v-for="(item, key) in this.cascadingCities" :value="item.id" :key="key" :label="item.name">
              </el-option>
            </el-select>
          </el-form-item> 
          <el-form-item class="inbox" style="width: calc(248 / 1920 * 100vw);">
            <el-form-item>
              <!-- <el-select class="inboxinput" v-model="formInline.DealerCode" placeholder="经销商" @change="dealerChange">
                <el-option v-for="(item, key) in this.cascadingDealers" :key="key" :value="item.code"
                  :label="item.name"></el-option>
              </el-select> -->
              <el-select
                class="inboxinput"
                v-model="formInline.DealerCode"
                placeholder="请选择经销商"
                @change="dealerChange"
                popper-class="select-option-dealer"
              >
                <el-option
                  v-for="(item, key) in this.cascadingDealers"
                  :key="key"
                  :value="item.code"
                  :label="item.name"
                  :disabled="item.isDisabled"
                >
                <template #default>
                  <div  style="display: flex;align-items: start;padding: 5px 0;">
                    <i v-if="formInline.DealerCode == item.code" class="el-icon-check" style="padding-top: 10px;font-weight: 700;"></i>
                    <div v-else style="width: 14px;height: 14px;"></div>
                    <div style="padding-left: 10px;" >
                      <div>{{ item.name }}</div>
                      <div style="color: rgba(180, 183, 192, 1);font-size: 12px;line-height: 20px;">{{ item.address }}</div>
                    </div>
                  </div>
                </template>
              </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item style="margin-bottom: auto !important;">
            <el-checkbox v-model="formInline.checked" className="agreement-checkbox" @change="checkboxChange"
              style="display: flex;justify-content: center;align-items: center;">
                <!-- <span class="tips">
                  我同意起亚及合作商就购买新车<br />事宜与我联系我同意提供电话号码
                </span> -->
                <span class="tips" style="color: #05141F99;white-space: nowrap;">
                已阅读并同意
                <span  style="text-decoration: underline;color: #05141F;white-space: nowrap;" @click="read" code-stm="event, PAGEURL, 隐私协议">
                  《隐私协议》
                </span>，
                <br />且同意起亚经销商与我联系。
              </span>
            </el-checkbox>
          </el-form-item>
          <el-form-item class="" style="margin-bottom: auto !important;">
            <el-button type="primary" @click="submitInformation"
              style="background-color: #000;color: #fff;border: none;" code-ga="event, PAGEURL, 悬浮提交按钮点击"
              code-stm="event, PAGEURL, 悬浮提交按钮点击">提 交</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div id="fullPageContainer" class="fullPageContainer" ref="fullPageContainer"></div>
      <div id="fullPageContainer" class="fullPageContainer" ref="fullPageContainer">
       <!-- <MobButton v-if="isPortrait"></MobButton> -->
        <Header @forbid="forbid" @open="open" />
        <ShareBar></ShareBar>

        <!-- !!!!!!!!!!!!!!!  mob start  !!!!!!!!!!!!!!!!!! -->
        <div v-if="isPortrait" class="mob-container">
          <div class="mob-chatbot-wrapper">
            <ChatBot :clientPosition="clientPosition" :noticeAccepted="noticeAccepted" />
          </div>
        </div>
        <!-- !!!!!!!!!!!!!!!  mob end  !!!!!!!!!!!!!!!!!! -->
        <!-- AI用户须知弹窗 -->
        <Popup @agree="onNoticeAgree" />
  
        <!-- !!!!!!!!!!!!!!!  pc start  !!!!!!!!!!!!!!!!!! -->
        <div v-if="!isPortrait" style="display: flex;padding-top: 78px;">
          <!-- 首页 欢迎页 （默认） -->
          <div v-if="leftPart == 'welcome'" class="welcome-part left-part" :style="leftPartStyle">
            <Welcome @stopAudio="stopAudio" @playAudio="playAudio"/>
          </div>
          <!-- 经销商 -->
          <div v-if="leftPart == 'dealers'" class="dealers-part left-part" :style="leftPartStyle">
            <Dealers :question="dealerQuestion" :clientPosition="clientPosition" />  
          </div>
          <!-- 多模态 -->
          <div v-show="leftPart == 'details' && !showMoreCard && !showMoreStripe" class="dealers-part left-part" :style="leftPartStyle">
            <Details 
            ref="detailsRef"
            :questionType="questionType" 
            :question="detailsQuestion" 
            @news-data="onDetailsNewsData" 
            @announcement-data="onDetailsAnnouncementData" 
            @activity-data="onDetailsActivityData" 
            @more-click="onMoreClick" />  
          </div>
          <!-- 车型对比 -->
          <div v-if="leftPart == 'compare'" class="dealers-part compare-part" :style="leftPartStyle">
            <Compare :question="compareQuestion" />  
          </div>
          <!-- 服务 -->
          <div v-if="leftPart == 'service' && !showMoreStripe" class="dealers-part left-part" :style="leftPartStyle">
     
            <Service ref="serviceRef" :question="serviceQuestion" @more-click="onServiceMoreClick" />  
          </div>
          <!-- 其他 -->
          <div v-if="leftPart == 'other' && !showMoreStripe" class="dealers-part left-part" :style="leftPartStyle">
     
            <Other ref="otherRef" :question="otherQuestion" :enhancedQuestion="otherEnhancedQuestion" @more-click="onOtherMoreClick" />  
          </div>
          <!-- 更多卡片 -->
          <div v-show="showMoreCard" class="dealers-part left-part" :style="leftPartStyle">
            <MoreCard 
            :news-list="detailsNewsData" 
            :activity-list="activityData" 
            :type-text="showMoreTypeText"
            :type="showMoreType"
            @back="showMoreCard = false" />  
          </div>
          <!-- 更多竖条 -->
          <div v-show="showMoreStripe" class="dealers-part left-part" :style="leftPartStyle">
            <MoreStripe 
            :dataList="showMoreType === 'announcement' && leftPart === 'service' ? serviceAnnouncementData : (showMoreType === 'announcement' && leftPart === 'other' ? otherAnnouncementData : announcementData)" 
            :type="showMoreType" 
            @back="showMoreStripe = false" />  
          </div>
          <!-- 可拖拽分隔条（仅PC） -->
          <div class="splitter" 
               title="拖动调整左右宽度"
               @mousedown="onSplitterDown" 
               @touchstart.prevent="onSplitterTouchStart"
               :style="splitterStyle"></div>

          <div class="right-part" :style="rightPartStyle">
            <ChatBot :clientPosition="clientPosition" :noticeAccepted="noticeAccepted" @change-left-part="onChangeLeftPart" />
          </div>
          <div alt="" style="position: fixed;top: 0;left: 0;width: 100%;z-index: -1;bottom: 0;">
            <img src="/assets/~/media/images/ai/bg.png" alt="" style="width: 100%;height: 100%;">
          </div>
        </div>
        <!-- !!!!!!!!!!!!!!!  pc end  !!!!!!!!!!!!!!!!!! --> 

        <!-- <div id="page1" class="section section6" ref="footer">
          <Footer />
        </div> -->
      </div>
      </div>
    </div>
</template>
<script>
import { apiUrl, pcdUrl, CSMUrl } from "@/config/base";
import { isPortraitFun, getUrlKey, throttle, debounce } from "@/utils/utils.js";
import $ from 'jquery'
import Header from "@/components/Header-co";
import ChatBot from '@/components/pc/Chat-Bot'
import Dealers from '@/components/pc/Dealers'
import Welcome from '@/components/pc/Welcome.vue';
import Details from "@/components/pc/Details.vue";
import Popup from "@/components/pc/Popup.vue";
import Compare from "@/components/pc/Compare.vue";
import MoreCard from "@/components/pc/MoreCard.vue";
import MoreStripe from "@/components/pc/MoreStripe.vue";
import Service from "@/components/pc/Service.vue";
import Other from "@/components/pc/Other.vue";

// Removed erroneous runtime import from 'sass' that pulled sass.dart.js into the client bundle

export default {
  name: 'index',
  components: { Header,ChatBot,Dealers,Details,Popup,Welcome,Compare,MoreCard,MoreStripe,Service,Other},
  computed: {
    leftPartStyle() {
      // 左侧宽 = 总宽 - 右侧宽 - 两侧间距(已在 class 中体现)，这里只控制宽度
      const right = this.rightWidthVW;
      const leftVW = 100 - right - (60 / 1920 * 100); // 减去固定右侧与外边距占比
      return { width: `calc(${leftVW}vw)` };
    },
    rightPartStyle() {
      return { width: `calc(${this.rightWidthVW}vw)` };
    },
    splitterStyle() {
      return {
        right: `calc(${this.rightWidthVW}vw + 20 / 1920 * 100vw)`,
      };
    }
  },
  data() {
    return {
      // leftPart: 'welcome',
      leftPart: 'welcome',
      dealerQuestion: '',
      // dealerQuestion_: '',
      compareQuestion: '',
      detailsQuestion: '',
      serviceQuestion: '',
      otherQuestion: '',
      otherEnhancedQuestion: '',
      detailsNewsData: [],
      announcementData: [], // 相关信息数据
      serviceAnnouncementData: [], // Service组件的相关信息数据
      otherAnnouncementData: [], // Other组件的相关信息数据
      activityData: [], // 相关活动数据

      showMoreCard: false,// 更多卡片
      showMoreStripe: false,// 更多竖条
      showMoreType: '',// 更多类型 activity: 相关活动, zixun: 相关资讯, announcement: 相关信息
      showMoreTypeText: '',// 更多类型文本

      // 音频控制相关状态
      isAudioPlaying: false,
      showLz: false,
      clientPosition: null,
      isPortrait: isPortraitFun(),
      noticeAccepted: false,
      lastTimeStamp: false,
      // minip: false,
      minip2: false,
      startY: 0,
      startX: 0,
      totalPage: 5,
      fullpage: {
        current: 1,
        isScrolling: false,
        deltaY: 0,
      },
      flag: false,
      cHeight: 0,
      isFullVideo: false,
      isAnimating: false,
      formInline: {
        CarSeriesCMSID:'436',
        CarSeriesName: "2025款 EV5",
        CarModelCMSID: "1407",
        CarModelName: "530 Land",
      },
      alldata: null,
      carAlldata: null,
      cascadingCities: [],
      cascadingDealers: [],
      showTopBtn: true,
      page5Height:200,
      page5Top:100,

      showVideoButton:false,
      page2Height:200,
      page2Top:100,

      showLogo:false,
      isPlaying: false, // 添加音频播放状态变量
      // 拖拽相关（仅PC）：右侧栏宽度（单位：vw）
      rightWidthVW: 30.8333333333, // 592 / 1920 * 100
      isDraggingSplitter: false,
      dragStartX: 0,
      dragStartRightVW: 30.8333333333,
    };
  },
  created() {
    // 初始化是否已同意用户须知（与 Popup 的存储策略一致）
    try {
      const ts = localStorage.getItem('kia_ai_notice_accepted_at');
      // 只要本地存储中存在记录，则视为已同意
      this.noticeAccepted = !!ts;
      // 未同意则立即退回首页
      if (!this.noticeAccepted) {
        try {
          const href = window.location.href || '';
          let target = '/';
          if (href.includes('uat.kia.cn')) {
            target = 'https://uat.kia.cn/';
          } else if (href.includes('kia.cn')) {
            target = 'https://www.kia.cn/';
          }
          // SPA 本地或非 kia 域名则回根路由
          if (!href.includes('kia.cn')) {
            try { this.$router && this.$router.replace && this.$router.replace('/'); return; } catch (_) {}
          }
          window.location.replace(target);
        } catch (_) {
          try { this.$router && this.$router.replace && this.$router.replace('/'); } catch (__) {}
        }
        return;
      }
    } catch (e) {
      this.noticeAccepted = false;
      // 容错：异常情况下也退回首页
      try { this.$router && this.$router.replace && this.$router.replace('/'); } catch (_) {}
    }
  },
  created() {
    // 无需处理AI权限，弹窗组件内部已处理展示与记忆

    if (!this.alldata) {
      console.log("try to fetch alldata from created");
      this.$axios.get(pcdUrl).then((res) => {
        console.log("fetched alldata from created", res.data);
        this.alldata = res.data;
        // this.$axios.get(CSMUrl).then((res1) => {
        //   debugger
        //   this.carAlldata = res1.data;
        //   this.formInline.CarSeriesCMSID="436"
        // });
        let that = this;
        fetch(CSMUrl).then(function (response) {
          return response.json();
        }).then(function (data) {
          console.log("车型车款数据", data);
          that.carAlldata = data;
          // this.formInline.CarSeriesCMSID="436"
        });
      });
    }
  },
  mounted: function () {
    setTimeout(() => {
      this.cutLocal()
      }, 2000);



    var browser = {
      versions: function () {
        var u = navigator.userAgent, app = navigator.appVersion;
        return { // 移动终端浏览器版本信息
          trident: u.indexOf('Trident') > -1, // IE内核
          presto: u.indexOf('Presto') > -1, // Opera内核
          webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
          gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, // 火狐内核
          mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/) && u.indexOf('QIHU') && u.indexOf('Chrome') < 0, // 是否为移动终端
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // iOS终端
          android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // Android 终端或者 UC 浏览器
          iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, // 是否为 iPhone 或者 QQHD 浏览器
          iPad: u.indexOf('iPad') > -1, // 是否 iPad
          webApp: u.indexOf('Safari') == -1, // 是否WEB应该程序，没有头部与底部。
          ua: u
        };
      }(),
      language: (navigator.browserLanguage || navigator.language).toLowerCase()
    }
    if (browser.versions.mobile && !browser.versions.iPad) {
      this.cHeight = document.documentElement.clientHeight
      window.addEventListener("resize", this.setResize);
      this.setResize()
    }
    if (navigator.userAgent.indexOf("Firefox") > -1) {
      var that = this;
      document.getElementById("fullPageContainer").addEventListener("DOMMouseScroll", function (e) {
        console.log(e);
        that.mouseWheel(e);
      });
      document.getElementById("fullPageContainer").onmousedown = function (e) {
        that.startX = e.clientX;
        that.startY = e.clientY;
      };
      document.getElementById("fullPageContainer").onmouseup = function (e) {
        if (that.fullpage.isScrolling) {
          return false;
        }
        console.log("touch 123123");
        // 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
        // event.preventDefault()
        let endx, endy;
        endx = e.clientX;
        endy = e.clientY;
        let direction = that.getDirection(that.startX, that.startY, endx, endy);
        switch (direction) {
          case 0:
            //alert("未滑动！");
            break;
          case 1:
            //alert("向上！")
            that.next();
            break;
          case 2:
            // alert("向下！")
            that.pre();
            break;
          case 3:
            //alert("向左！")
            break;
          case 4:
            //alert("向右！")
            break;
          default:
        }
      };
    }

    const _that = this
    // if (getUrlKey("minip")) {
    //   this.minip = true
    //   this.totalPage = 5
    // }
    if (getUrlKey("minip") && getUrlKey("minip") == 2) {
      this.minip2 = true;
    }

    document.onkeydown = function (e) {
      const ev = e || window.event;
      if (_that.fullpage.isScrolling) {
        return false;
      }
      switch (ev.keyCode) {
        case 38:
          _that.pre()
          break;
        case 40:
          _that.next()
          break;
        default:
          // console.log("请按上下左右键");
          break;
      }
      // console.log(ev.keyCode);
    }
    window.addEventListener('scroll', this.handleScroll);
    this.page5Height = document.getElementById("page5").offsetHeight
    this.page5Top= document.getElementById("page5").offsetTop
    this.page2Height = document.getElementById("page2").offsetHeight
    this.page2Top = document.getElementById("page2").offsetTop

    //滚出视频区域暂停
    window.addEventListener('scroll', function() {
          const video= document.getElementById("videoPlayerFull")
          const video1= document.getElementById("videoPlayerFull1")
          var vh = window.innerHeight;
          var vw = window.innerWidth;
          if(!_that.isPortrait){//pc
            //  if(document.getElementById("page2")){
            //    var pageTopPc= document.getElementById("page2").getBoundingClientRect().top
            //    console.log(pageTopPc)
            //    if(pageTopPc <= - 9 / 16 * vw ){
            //      video.pause()
            //    }
            //  }
          }else{//mob
             if(document.getElementById("page2")){
               var pageTopMob= document.getElementById("page2").getBoundingClientRect().top
               // console.log(pageTopPc)
               if(pageTopMob <= - 9 / 10 * vw  ){
                 video1.pause()
               }
             }
          }
        })
  },
  beforeDestroy() {
    const music = document.getElementById("music");
    music.src = ""
    music.stop();
  },
  methods: {
    onSplitterDown(e) {
      try {
        this.isDraggingSplitter = true;
        this.dragStartX = e.clientX || (e.touches && e.touches[0] && e.touches[0].clientX) || 0;
        this.dragStartRightVW = this.rightWidthVW;
        window.addEventListener('mousemove', this.onSplitterMove);
        window.addEventListener('mouseup', this.onSplitterUp);
      } catch (_) {}
    },
    onSplitterTouchStart(e) {
      try {
        this.isDraggingSplitter = true;
        this.dragStartX = (e.touches && e.touches[0] && e.touches[0].clientX) || 0;
        this.dragStartRightVW = this.rightWidthVW;
        window.addEventListener('touchmove', this.onSplitterTouchMove, { passive: false });
        window.addEventListener('touchend', this.onSplitterTouchEnd);
      } catch (_) {}
    },
    onSplitterMove(e) {
      if (!this.isDraggingSplitter) return;
      const deltaPx = (e.clientX || 0) - this.dragStartX;
      const deltaVW = (deltaPx / window.innerWidth) * 100;
      let next = this.dragStartRightVW - deltaVW;
      // 约束范围：右侧最小 20vw，最大 45vw
      next = Math.max(20, Math.min(45, next));
      this.rightWidthVW = next;
    },
    onSplitterUp() {
      this.isDraggingSplitter = false;
      window.removeEventListener('mousemove', this.onSplitterMove);
      window.removeEventListener('mouseup', this.onSplitterUp);
    },
    onSplitterTouchMove(e) {
      if (!this.isDraggingSplitter) return;
      if (e && e.preventDefault) e.preventDefault();
      const touch = e.touches && e.touches[0];
      if (!touch) return;
      const deltaPx = touch.clientX - this.dragStartX;
      const deltaVW = (deltaPx / window.innerWidth) * 100;
      let next = this.dragStartRightVW - deltaVW;
      next = Math.max(20, Math.min(45, next));
      this.rightWidthVW = next;
    },
    onSplitterTouchEnd() {
      this.isDraggingSplitter = false;
      window.removeEventListener('touchmove', this.onSplitterTouchMove);
      window.removeEventListener('touchend', this.onSplitterTouchEnd);
    },
    onNoticeAgree() {
      this.noticeAccepted = true;
    },
    onMoreClick(type) {

      if(type == 'activity') {
        this.showMoreCard = true;
        this.showMoreType = 'activity';
        this.showMoreTypeText = '相关活动';
      }
      if(type == 'zixun') {
        this.showMoreCard = true;
        this.showMoreType = 'zixun';
        this.showMoreTypeText = '相关资讯';
      }
      if(type == 'announcement') {
        this.showMoreStripe = true;
        this.showMoreType = 'announcement';
      }
    },
    onServiceMoreClick(data) {
      console.log('Service more-click:', data);
      if (data && data.type === 'announcement') {
        this.serviceAnnouncementData = data.data || [];
        this.showMoreStripe = true;
        this.showMoreType = 'announcement';
      }
    },
    onOtherMoreClick(data) {
      console.log('Other more-click:', data);
      if (data && data.type === 'announcement') {
        this.otherAnnouncementData = data.data || [];
        this.showMoreStripe = true;
        this.showMoreType = 'announcement';
      }
    },   
    onDetailsNewsData(list){
      this.detailsNewsData = Array.isArray(list) ? list : []
    },
    onDetailsAnnouncementData(list){
      this.announcementData = Array.isArray(list) ? list : []
    },
    onDetailsActivityData(list){
      this.activityData = Array.isArray(list) ? list : []
    },
    onChangeLeftPart(part, payload,questionType,enhancedQuestion) {
      console.log('onChangeLeftPart 被调用:', { part, payload,questionType,enhancedQuestion }); 
      // 仅在PC端切换左侧面板；移动端忽略（由ChatBot内部弹层处理）
      if (!this.isPortrait) {
        this.leftPart = part;
        if (part === 'dealers' && payload) { 
          this.dealerQuestion = payload;
        }
        if (part === 'compare' && payload) {
          this.compareQuestion = payload;
        }
        if (part === 'details' && payload) {
          // 强制触发更新，即使payload相同
          console.log('设置detailsQuestion:', payload);
          this.detailsQuestion = payload;
          this.questionType = questionType;
        }
         if (part === 'details' && payload) {
          // 强制触发更新，即使payload相同
          console.log('设置detailsQuestion:', payload);
          this.detailsQuestion = payload;
          this.questionType = questionType//questionIntact;
        }
         if (part === 'details') { 
          // 直接调用Details组件的handleQuestionChangeImgView方法
          if (this.$refs.detailsRef) {
            this.$refs.detailsRef.handleQuestionChangeImgView(payload, enhancedQuestion,questionType);
          }
        }
        //3.0 增加品牌服务场景
        if (part === 'service' && payload) {
          this.serviceQuestion = payload;
          if (this.$refs.serviceRef) {
            this.$refs.serviceRef.handleQuestionChange(payload);
          }
        }
        //4.0 增加其他问题提问场景
        if (part === 'other' ) {
          this.otherQuestion = payload;
          this.otherEnhancedQuestion = enhancedQuestion; 
          if (this.$refs.otherRef) {
            this.$refs.otherRef.handleQuestionChange(payload, enhancedQuestion,questionType);
          }
        }
      }
    },
    handleAudio(){
      // this.isAudioPlaying = !this.isAudioPlaying;
      // this.showAudioText = !this.isAudioPlaying;

      // 触发音频播放/暂停事件
      if (!this.isAudioPlaying) {
        this.playAudio();
      } else {
        this.stopAudio();
      }
      if(!this.isAudioPlaying){
        stm_clicki("send",'event',window.location.href, "点击", '播放音频');
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '播放音频', 1]);
      }else{
        stm_clicki("send",'event',window.location.href, "点击", '暂停音频');
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '暂停音频', 1]);
      }
    },
    stopAudio(){
      const music = document.getElementById("music");
      music.pause()
      this.isAudioPlaying = false;
    },
    playAudio(){
      const music = document.getElementById("music");
      music.src = "https://img.kia.cn/media/videos/202506/dadianying-zhutige.mp3"
      music.play()
      this.isAudioPlaying = true;
    },

    play2(){
      this.stopAudio()
      const video1 = document.getElementById("videoPlayerSwiper0")
      const video2 = document.getElementById("videoPlayerSwiper1")
      // const video3 = document.getElementById("videoPlayerSwiper2")
      if(video1){
        video1.pause()
      }
      if(video2){
        video2.pause()
      }
      this.$refs.onlyVideo.play2();

    },
    liuzi() {
      this.showLz = true
    },
    close() {
      this.showLz = false
    },
    read() {
      // this.$router.push({
      //   path: "/terms",
      // });
      const route = this.$router.resolve({ path: '/terms' });
      const href = route.href;
      window.open(href, '_blank');
    },
    checkboxChange(e){
      if(e == true){
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '勾选', 1]);
      }else{
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '取消勾选', 1]);
      }
    },
    handleScroll () {
        const scrollTop = (window.scrollY || document.documentElement.scrollTop);
        this.showTopBtn = (scrollTop < this.page5Top-this.page5Height + 200) ;
        // console.log('scrollTop'+ scrollTop+ 'page2Top' +this.page2Top);
        if(document.getElementById("page2")){
          var pageTopMob= document.getElementById("page2").getBoundingClientRect().top
        }
        var vw = window.innerWidth;
        var vh = window.innerHeight;
        this.showVideoButton = (pageTopMob <= - 750 / 375 * vw &&  pageTopMob >= - 5400 /  375 * vw);
        this.showLogo = (scrollTop > vh && scrollTop < this.page5Top-this.page5Height - 200);
    },
    async cutLocal() {
            try {
                console.log('开始定位...');
                
                // 先尝试使用浏览器原生定位 API（更快、更可靠）
                if (navigator.geolocation) {
                    console.log('使用浏览器原生定位 API');
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            const lng = position.coords.longitude;
                            const lat = position.coords.latitude;
                            console.log('浏览器定位成功，经纬度:', { lng, lat });
                            
                            // 立即保存经纬度
                            this.clientPosition = { lng, lat };
                            this.$forceUpdate();
                            console.log('clientPosition 已更新（浏览器定位）:', this.clientPosition);
                            
                            // 然后使用百度地图进行逆地理编码
                            this.load().then((map) => {
                                if (map && map.Map) {
                                    var myGeo = new map.Geocoder();
                                    myGeo.getLocation(new map.Point(lng, lat), (result) => {
                                        if (result && result.addressComponents) {
                                            const params = Object.assign({ lng, lat }, result.addressComponents);
                                            this.clientPosition = params;
                                            this.$forceUpdate();
                                            console.log('clientPosition 已更新（含地址信息）:', this.clientPosition);
                                            
                                            // 设置表单
                                            if (params.province && this.alldata && this.alldata.province) {
                                                const provinceMatch = this.alldata.province.find(item => item.name == params.province);
                                                if (provinceMatch) {
                                                    this.formInline.Province = provinceMatch.id;
                                                    this.setCity(true);
                                                    if (params.city && this.alldata && this.alldata.city && this.alldata.city[this.formInline.Province]) {
                                                        const cityMatch = this.alldata.city[this.formInline.Province].find(item => item.name == params.city);
                                                        if (cityMatch) {
                                                            this.formInline.City = cityMatch.id;
                                                            this.cityChange(this.formInline.City);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }, (err) => {
                                        console.warn('逆地理编码失败，但经纬度已保存');
                                    });
                                }
                            });
                        },
                        (error) => {
                            console.warn('浏览器定位失败，尝试使用百度地图定位:', error);
                            // 浏览器定位失败，使用百度地图定位作为备用
                            this.tryBaiduMapLocation();
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 10000,
                            maximumAge: 0
                        }
                    );
                } else {
                    console.warn('浏览器不支持定位，使用百度地图定位');
                    this.tryBaiduMapLocation();
                }
            } catch (error) {
                console.error('定位过程中发生错误:', error);
                this.tryBaiduMapLocation();
            }
        },
        // 百度地图定位备用方案
        async tryBaiduMapLocation() {
            try {
                let map = await this.load()
                let _this = this
                if (map && map.Map) {
                    console.log('百度地图API加载成功，开始获取位置');
                    let funL = new map.Geolocation()
                    funL.getCurrentPosition((res) => {
                        console.log('百度地图定位回调结果:', res);
                        // 如果存在经纬度
                        if (res && res.point && res.point.lng && res.point.lat) {
                            // 先立即保存经纬度，确保即使逆地理编码失败也有位置信息
                            const baseParams = {
                                lng: res.point.lng,
                                lat: res.point.lat
                            };
                            console.log('获取到经纬度:', baseParams);
                            
                            // 立即设置 clientPosition
                            _this.clientPosition = baseParams;
                            _this.$forceUpdate();
                            console.log('clientPosition 已更新:', _this.clientPosition);
                            console.log('验证 clientPosition 值:', JSON.stringify(_this.clientPosition));
                            
                            // 然后尝试逆地理编码获取地址信息
                            var myGeo = new map.Geocoder();
                            myGeo.getLocation(new map.Point(res.point.lng, res.point.lat), function (result) {
                                console.log('逆地理编码结果:', result);
                                // 如果逆地理编码成功，合并地址信息
                                if (result && result.addressComponents) {
                                    const params = Object.assign({}, baseParams, result.addressComponents);
                                    // 更新 clientPosition
                                    _this.clientPosition = params;
                                    _this.$forceUpdate();
                                    console.log('clientPosition 已更新（含地址信息）:', _this.clientPosition);
                                    
                                    // 如果有省份信息，尝试设置表单
                                    if (params.province && _this.alldata && _this.alldata.province) {
                                        const provinceMatch = _this.alldata.province.find(item => item.name == params.province);
                                        if (provinceMatch) {
                                            _this.formInline.Province = provinceMatch.id;
                                            _this.setCity(true);
                                            if (params.city && _this.alldata && _this.alldata.city && _this.alldata.city[_this.formInline.Province]) {
                                                const cityMatch = _this.alldata.city[_this.formInline.Province].find(item => item.name == params.city);
                                                if (cityMatch) {
                                                    _this.formInline.City = cityMatch.id;
                                                    _this.cityChange(_this.formInline.City);
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    console.log('逆地理编码无地址信息，但经纬度已保存');
                                }
                            }, function(err) {
                                console.warn('逆地理编码失败，但已保存经纬度:', baseParams);
                                console.log('当前 clientPosition:', _this.clientPosition);
                            });
                        } else {
                            console.warn('定位成功但未获取到经纬度信息', res);
                        }
                    }, (err) => {
                        // 定位失败
                        console.warn('百度地图定位失败:', err);
                        console.error('定位错误详情:', JSON.stringify(err));
                    })
                } else {
                    console.warn('百度地图API加载失败，map:', map);
                }
            } catch (error) {
                console.error('百度地图定位过程中发生错误:', error);
            }
        },

    // 定位城市
    load() {
      return new Promise((resolve, reject) => {
        if (!this.BMap) {
          $.getScript('//api.map.baidu.com/api?v=2.0&ak=4ybCJ1rBffkf2PFgkvsRJuqAV9XBtnHq&callback=initialize', function (res) {
            console.log("百度", res);
            let num = 1
            let time = setInterval(() => {
              if (BMap.Map) {
                this.BMap = true
                resolve(BMap)
                clearInterval(time)
              }
              num++
            }, 25)
          })
        } else {
          resolve(BMap)
        }
      })
    },
    distinctive(e) {
      this.isFullVideo = e
    },
    setResize() {
      var that = this
    },
    forbid() {
      this.flag = true;
    },
    open() {
      this.flag = false;
    },
    custormAnchor(anchorName) {
      // window.location = "https://www.kia.cn/activity/2022/08/nq5cpay/7yhegE3/index.html#/?utm_source=&utm_soid=&utm_activity=&mz_ca=&mz_sp="
      this.directToMove(6);
      // // 找到锚点
      // let anchorElement = document.getElementById(anchorName);
      // // 如果对应id的锚点存在，就跳转到锚点
      // if(anchorElement) { anchorElement.scrollIntoView(); }
    },
    getAngle(angx, angy) {
      return Math.atan2(angy, angx) * 180 / Math.PI;
    },
    //根据起点终点返回方向 1向上 2向下 3向左 4向右 0未滑动
    getDirection(startx, starty, endx, endy) {
      let angx = endx - startx;
      let angy = endy - starty;
      let result = 0;

      //如果滑动距离太短
      if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
        return result;
      }

      let angle = this.getAngle(angx, angy);
      if (angle >= -135 && angle <= -45) {
        result = 1;
      } else if (angle > 45 && angle < 135) {
        result = 2;
      } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
        result = 3;
      } else if (angle >= -45 && angle <= 45) {
        result = 4;
      }

      return result;
    },
    getTouchstartY() {
      this.startY = event.changedTouches[0].pageY  //将手指对应的y轴坐标赋值给data中的startY
      this.startX = event.changedTouches[0].pageX
    },
    touchmove() {
      if (this.flag == true) {
        e.preventDefault()
      }
      let evt = event || window.event;
      if (evt.stopPropagation) {
        evt.stopPropagation();
      } else {
        evt.returnValue = false;
      }
      if (this.fullpage.isScrolling) {
        return false;
      }
      console.log('touch 123123')
      // 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
      // event.preventDefault()
      let endx, endy;
      endx = event.changedTouches[0].pageX;
      endy = event.changedTouches[0].pageY;
      let direction = this.getDirection(this.startX, this.startY, endx, endy);
      switch (direction) {
        case 0:
          //alert("未滑动！");
          break;
        case 1:
          //alert("向上！")
          this.next()
          break;
        case 2:
          // alert("向下！")
          this.pre()
          break;
        case 3:
          //alert("向左！")
          break;
        case 4:
          //alert("向右！")
          break;
        default:
      }

    },
    next() {
      let len = this.totalPage;
      if (this.fullpage.current + 1 <= len) {
        this.fullpage.current += 1;
        this.move(this.fullpage.current);
      }
    },
    pre() {
      if (this.fullpage.current - 1 > 0) {
        this.fullpage.current -= 1;
        this.move(this.fullpage.current);
      }
    },
    move: throttle(function (index) {

      this.fullpage.isScrolling = true;
      this.directToMove(index);
      setTimeout(() => {
        this.fullpage.isScrolling = false;
      }, 800);

      let videos1 = document.querySelectorAll(".preview-video")[0];
      if (!videos1) {
        return
      }
      if (index == 2) {
        videos1.play();
      } else {
        videos1.pause();
      }
      // let videos2 = document.querySelectorAll(".full-video")[0];
      // if (!videos2 ) {
      //   return
      // }
      // if(!this.isFullVideo){
      //   return
      // }
      // if (index == 2) {
      //   videos2.play();
      // } else {
      //   videos2.pause();
      // }
    }, 800, true),
    directToMove(index) {
      let height = this.$refs["fullPage"].clientHeight;
      let scrollPage = this.$refs["fullPageContainer"];
      // console.log(height)
      let scrollHeight;
      scrollHeight = -(index - 1) * height + "px";
      if (index === this.totalPage) {
        scrollHeight = -(index - 2) * height - this.$refs["footer"].clientHeight + "px";
      }
      scrollPage.style.transform = `translate3d(0,0,0) translateY(${scrollHeight})`;
      this.fullpage.current = index;
    },
    mouseWheel: throttle(function (event) {
      if (this.flag == true) {
        e.preventDefault()
      }
      console.log(123123, this.fullpage.isScrolling)
      let evt = event || window.event;
      if (evt.stopPropagation || evt.preventDefault) {
        evt.stopPropagation();
        evt.preventDefault();
      } else {
        evt.returnValue = false;
      }
      if (this.fullpage.isScrolling) {
        return false;
      }
      let e = event.originalEvent || event;
      this.fullpage.deltaY = e.deltaY || e.detail;
      if (this.fullpage.deltaY > 0) {
        this.next();
      } else if (this.fullpage.deltaY < 0) {
        this.pre();
      }
    }, 100, true),

  initData() {
    let that = this;
    this.$axios.get(CSMUrl).then((res) => {
      that.carAlldata = res.data;
    });
  },
  setProvince() {
    this.formInline.City = "";
    this.setCity();
  },

  setCity(fromLocation = false) {
    // this.cascadingCities = this.alldata.city[this.formInline.Province];
    this.cascadingCities = [];
    if (this.alldata && this.alldata.city && this.alldata.city[this.formInline.Province]) {
      this.alldata.city[this.formInline.Province].forEach((cityIter) => {
        //过滤city
        if (
          this.alldata.cityRelType && 
          this.alldata.cityRelType[cityIter.id] && 
          (this.alldata.cityRelType[cityIter.id].includes("1") ||
          this.alldata.cityRelType[cityIter.id].includes("4"))
        ) {
          this.cascadingCities.push(cityIter);
        }
      });
    }
    if(!fromLocation){
      if(this.formInline.City){
        this.$set(this.formInline, 'City', this.formInline.City);
      }else{
        this.$set(this.formInline, 'City', this.cascadingCities[0].id);
      }
      // this.formInline.City = this.formInline.City || this.cascadingCities[0].id;
    }else{
      // #如果未找到对应城市数据(因为他没有经销商 所以alldata城市字典表中没这个城市),则默认选中第一个
      // this.formInline.City = this.cascadingCities.find((city) => city.name === this.clientPosition.city)?.id || this.cascadingCities[0].id
      if(!this.cascadingCities.find((city) => city.id === this.formInline.City)){
          // this.formInline.City = ''
          this.$set(this.formInline, 'City', '');
      }
    }
    this.cityChange(this.formInline.City);
  },
  async cityChange(cityId) {
    if (!cityId) {
          return;
    }
    let map = await this.load();
    let baiduMap = new map.Map();
    //改变经销商数据/起点
    if (this.alldata && this.alldata.dealer && this.alldata.dealer[cityId]) {
      let temp = this.alldata.dealer[cityId];
      this.cascadingDealers = [];
      temp.forEach((origin) => {
      if (origin.type == "1" || origin.type == "7") {
        const originPosition = new BMap.Point(
          origin.latitude,
          origin.longitude
        );
        const nowPosition = new BMap.Point(
          this.clientPosition.lng,
          this.clientPosition.lat
        );
        this.cascadingDealers.push({
          ...origin,
          distance: this.getMapDistance(
            nowPosition,
            originPosition,
            baiduMap
          ),
          isDisabled: origin.isException === "是",
        });
      }
    });
    this.cascadingDealers = this.cascadingDealers.sort((a, b) => {
      // 首先处理 isException 的情况
      if (a.isException === "是" && b.isException !== "是") {
        return 1; // a 排在 b 后面
      } else if (a.isException !== "是" && b.isException === "是") {
        return -1; // b 排在 a 后面
      }
      return a.distance - b.distance;
    });
    // if (this.cascadingDealers.length) {
    //   this.formInline.DealerCode = this.cascadingDealers[0].code;
    //   this.formInline.DealerName = this.cascadingDealers[0].name;
    // }
    if (this.cascadingDealers.length) {
      this.$set(this.formInline, 'DealerCode', this.cascadingDealers[0].code);
      this.$set(this.formInline, 'DealerName', this.cascadingDealers[0].name);
    }
    }
  },
  setCarSeries() {
    this.formInline.CarModelCMSID = "";
    console.log(
      "this.formInline.CarSeriesCMSID",
      this.formInline.CarSeriesCMSID
    );
    if (this.formInline.CarSeriesCMSID && this.carAlldata && this.carAlldata.model && this.carAlldata.model[this.formInline.CarSeriesCMSID]) {
      // this.formInline.CarModelCMSID = this.carAlldata.model[this.formInline.CarSeriesCMSID].at(-1).cmsid;
      const modelArray = this.carAlldata.model[this.formInline.CarSeriesCMSID];
      if (modelArray && modelArray.length > 0) {
        this.formInline.CarModelCMSID = modelArray[modelArray.length - 1].cmsid;
        // this.formInline.CarModelName = this.carAlldata.model[this.formInline.CarSeriesCMSID].at(-1).name;
        this.formInline.CarModelName = modelArray[modelArray.length - 1].name;
      }
    }
    console.log('this.formInline.CarModelName', this.formInline.CarModelName);
  },
  getMapDistance(centerPoint, otherPoint, map) {
    let distance = map.getDistance(centerPoint, otherPoint);
    return (distance / 1000).toFixed(2);
  },
  dealerChange(dealerCode) {
    let dealer = this.cascadingDealers.find((value) => {
      return value.code === dealerCode;
    });
    this.formInline.DealerCode =
      dealer == null ? this.cascadingDealers[0].code : dealer.code;
    this.formInline.DealerName =
      dealer == null ? this.cascadingDealers[0].name : dealer.name;
  },
  submitInformation() {
    console.log(this.formInline);
    if (
      !this.formInline.Name ||
      !this.formInline.Phone ||
      !this.formInline.CarSeriesCMSID
    ) {
      this.$message.error("请完善信息后再次提交");
      return;
    }
    //获取车型名字
    // console.log(this.carSeries)
    let CarSeriesName = null;
    if (this.carAlldata && this.carAlldata.series) {
      CarSeriesName = this.carAlldata.series.find((item, index) => {
        return item.cmsid === this.formInline.CarSeriesCMSID;
      });
    }
    //获取默认经销商名字和编码
    if (!this.formInline.DealerCode || !this.formInline.DealerName) {
      this.formInline.DealerCode = this.cascadingDealers[0].code;
      this.formInline.DealerName = this.cascadingDealers[0].name;
    }
    //将省市转化成字符串
    let provinceStr = null;
    let cityStr = null;
    if (this.alldata && this.alldata.province) {
      provinceStr = this.alldata.province.find(
        (item) => item.id === this.formInline.Province
      );
    }
    if (this.alldata && this.alldata.city && this.alldata.city[this.formInline.Province]) {
      cityStr = this.alldata.city[this.formInline.Province].find(
        (item) => item.id === this.formInline.City
      );
    }
    provinceStr = provinceStr?.name || '';
    cityStr = cityStr?.name || '';

    if (!this.formInline.checked) {
      this.$message.error("请先同意起亚及合作商就购买新车事宜与您联系您同意提供电话号码");
      return;
    }
    let subFormDrive = {
      //媒体来源、活动来源、媒体渠道ID没写
      CarBuyingTime: "-",
      carModelCmsid: this.formInline.CarModelCMSID,
      carModelName: this.formInline.CarModelName,
      carSeriesCmsid: this.formInline.CarSeriesCMSID,
      carSeriesName: CarSeriesName.name,
      cityName: cityStr,
      dealerCode: this.formInline.DealerCode,
      dealerName: this.formInline.DealerName,
      provinceName: provinceStr,
      userName: this.formInline.Name,
      userPhone: this.formInline.Phone,
      Code: this.formInline.Code,
      smartCode: getUrlKey("utm_source") || "官网", //媒体来源
      activity: getUrlKey("utm_activity") || "田亮专题页预约试驾（官网）", //活动名称
      extraSix: getUrlKey("utm_soid") || "76",
    };
    //预约试驾接口
    this.$axios
        .post(`${apiUrl}clue/australiaPage`, subFormDrive)
        .then((res) => {
      console.log(99999998888, res);
      if (res.data.success) {
        this.$message.success("预约试驾成功");
        console.log(subFormDrive);
        setTimeout(() => {
          // this.formInline.CarModelCMSID = "";
          // this.formInline.CarSeriesCMSID = "";
          // this.formInline.DealerCode = "";
          // this.formInline.DealerName = "";
          // this.formInline.Name = "";
          // this.formInline.Phone = "";
          // this.formInline.Code = "";
          // this.formInline.City = "";
          // this.formInline.Province = "";
          // this.formInline.checked = false;
        }, 1000);
      } else {
        this.$message.error("预约试驾失败:" + res.data.message);
        console.log(subFormDrive);
        console.log(res.msg);
      }
    });
  },
  gotoBlock(e) {
    // console.log(e);
    // const el = this.$refs[`pc-block${e}`];
    var _that = this
    if (!this.isPortrait) {
      if (!this.isAnimating) {
        this.isAnimating = true;
        // 在动画结束后将 isAnimating 设置为 false，以便下次点击重新触发动画
        setTimeout(() => {
          this.isAnimating = false;
        }, 1000); // 假设动画持续 3 秒钟
      }
    } else {
    //   const el = this.$refs[`pc-block${e}`];
    //   el.scrollIntoView()
       var top =  this.page5Top;
    //    页面滚动到top距离
         window.scrollTo({
            top: top,
         });
      _that.showTopBtn = false
    }
  },
}
}

</script>

<style>
.my-select-style {
  @media (min-width: 767px) {
    z-index: 800 !important;
  }
}
</style>
<style lang="scss" scoped>
// 
.welcome-part {
  padding: calc(26 / 1920 *  100vw) 0 0 calc(40 / 1920 *  100vw);
  background-color: rgba(255, 255, 255, 0.5);
  overflow-y: auto;
}
.dealers-part {
  background-color: #fff;
  overflow: hidden;
}
.compare-part {
  width: calc(100% - 592 / 1920 * 100vw - 60 / 1920 * 100vw);//calc(100% - 336px - 60 / 1920 * 100vw);
  position: relative; 
  // margin:calc(20 / 1080 * 100vh);
  margin:calc(20 / 1920 * 100vw) calc(20 / 1080 * 100vh) calc(20 / 1920 * 100vw) calc(20 / 1080 * 100vh);
  min-height: calc(100vh - 78px - 40 / 1920 * 100vw);
  height: calc(100vh - 78px - 40 / 1920 * 100vw);
  
  border-radius: calc(12 / 1920 * 100vw);
  overflow: auto;
}
.left-part {
  //按宽比例
  // width: calc(1343 / 1920 * 100vw);
  //固定宽
  width: calc(100% - 592 / 1920 * 100vw - 60 / 1920 * 100vw);//calc(100% - 336px - 60 / 1920 * 100vw);
  position: relative; 
  margin:calc(20 / 1920 * 100vw) calc(20 / 1080 * 100vh) calc(20 / 1920 * 100vw) calc(20 / 1080 * 100vh);
  min-height: calc(100vh - 78px - 40 / 1920 * 100vw);
  height: calc(100vh - 78px - 40 / 1920 * 100vw);
  
  border-radius: calc(12 / 1920 * 100vw);
  overflow: auto;
  
  /* 自定义滚动条样式 */
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    transition: background 0.3s ease;
    
    &:hover {
      background: rgba(0, 0, 0, 0.4);
    }
  }
  
  /* Firefox 滚动条样式 */
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);
}
.right-part {
  //按宽比例
  // width: calc(504 / 1920 * 100vw);
  //固定宽
  width: calc(592 / 1920 * 100vw);//336px;

  position: fixed;
  right: calc(20 / 1920 * 100vw);
  top: calc(78px + 20 / 1920 * 100vw);
  bottom: calc(20 / 1920 * 100vw);
}
.splitter {
  position: fixed;
  top: calc(78px + 20 / 1920 * 100vw);
  bottom: calc(20 / 1920 * 100vw);
  width: 14px;
  cursor: col-resize;
  z-index: 90;
  background: rgba(5, 20, 31, 0.08);
  border-radius: 999px;
  box-shadow: 0 0 0 1px rgba(5, 20, 31, 0.08) inset;
  display: flex;
  align-items: center;
  justify-content: center;
}
.splitter::before {
  content: '';
  display: block;
  width: 4px;
  height: 24px;
  border-radius: 2px;
  background: linear-gradient(
    to bottom,
    rgba(5, 20, 31, 0.45) 0,
    rgba(5, 20, 31, 0.45) 4px,
    transparent 4px,
    transparent 8px,
    rgba(5, 20, 31, 0.45) 8px,
    rgba(5, 20, 31, 0.45) 12px,
    transparent 12px,
    transparent 16px,
    rgba(5, 20, 31, 0.45) 16px,
    rgba(5, 20, 31, 0.45) 20px,
    transparent 20px,
    transparent 24px
  );
}
.select-option-dealer .el-select-dropdown__item {
  height: auto !important;
  padding: 0 10px;
}
.el-select-dropdown__item.selected {
  font-weight: 500 !important;
}
.fullPage {
  padding: 0;
  margin: 0;
  /* height: calc(100vh); */
  /* overflow: hidden; */

  // background-color: #fff;
  // background-color: rgba(35, 107, 180, 1);
  color: #000000;
  // background-color: #000;
}

.fullPageContainer {
  width: 100%;
  /* height: calc(100vh); */
  transition: all ease-out 0.8s;
}

.section {
  width: 100%;
  // height: calc(100vh);
  @media (max-width:767px) {
    height: calc(742 / 375 * 100vw);
    background-color: #000;
  }
  background-position: center center;
  background-repeat: no-repeat;
  /* transform: translate3d(0, 0, 0); */
  overflow: hidden;
}

.section5 {
  margin-top: -3px;
  /* background: #F6F3EE; */
  // background-image: url('https://www.kia.cn/assets/~/media/images/activity/aowang2025/fourth-page-background-mob.png');
  // background-repeat: no-repeat;
  /* 防止重复 */
  // background-size: 100% 100%;
  background-size: cover;
}

.section6 {
  height: auto;
  background: #000000;
}

.oneform {
  background-color: rgb(255, 255, 255, 0.7);
  text-align: center;
  padding-top: 10px;
  width: 100%;
  position: fixed;
  bottom: 0;
  z-index: 100;
}

.animate {
  animation: heightAni 1s ease-in-out forwards;
  /* 假设动画持续 3 秒钟 */
}

// ::v-deep .el-input__inner {
//   background-color: rgb(255, 255, 255, 0.7) ;;
//   border-radius: unset;
//   color: #fff;

//   &::placeholder {
//     color: rgb(148 148 149);
//   }
// }
.tips {
  font-size: calc(16 / 2200 * 100vw);
    // color: #FFFFFF99;
    // text-align: left;
    // display: flex;
}
.inbox {
  width: calc(178 / 1920 * 100vw);
  margin-bottom: 10px;
}
.inboxinput > ::v-deep.el-input__inner{
  background-color: rgb(255, 255, 255, 0.7) ;
  border-radius: unset;
  color: #000000;

  &::placeholder {
    color: rgb(148 148 149);
  }
}

.inboxinput > ::v-deep.el-input> .el-input__inner{
  background-color: rgb(255, 255, 255, 0.7) ;;
  border-radius: unset;
  color: #000000;

  &::placeholder {
    color: rgb(148 148 149);
  }
}
::v-deep .el-checkbox__inner {
  background: transparent;
  border: 1px solid rgba($color: #19191C, $alpha: 0.3);
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #19191C;
  border-color: #19191C;
}
.logo-box {
  z-index: 30 !important;
  position: fixed;
  left: 3vw;
  top: 120px;
  z-index: 3;
  img {
    width: 100px;
    object-fit: cover;
  }
}
.play-audio {
    position: fixed;
    bottom: 50px;
    left:calc(39 / 375 * 100vw + 41 / 375 * 100vw + 10 / 375 * 100vw);
    // width: calc(41 / 375 * 100vw);
    // height: calc(41 / 375 * 100vw);
    width: calc(50 / 375 * 100vw);
    height: calc(59 / 375 * 100vw);
    position: fixed;
    z-index: 999;
    img {
      position: relative;
      width: 100%;
      height: 100%;
      transition: transform 0.5s ease;
      z-index: 1000;
      &.rotate {
        animation: rotate 3s linear infinite;
      }
    }

    .audio-text {
      position: absolute;
      top: 0;
      left: 0;
      width: calc(50 / 375 * 100vw);
      height: calc(59 / 375 * 100vw);
      // transform: translateX(-20px);
      opacity: 0;
      transition: all 0.3s ease;
      pointer-events: none;
      z-index:999;
      &.show {
        // transform: translateX(10px);
        opacity: 1;
      }

      img {
        width: 100%;
        height: 100%;
        animation: none;
      }
    }
  }
.yy-box {
  width: calc(41 / 375 * 100vw);
  height: calc(59 / 375 * 100vw);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  z-index: 1000;
  // img {
  //   width: 24px;
  //   margin-bottom: 20px;
  //   animation: tbmove 0.7s infinite;
  //   // height: ;
  // }

  // &-btn {
  //   width: 80%;

  //   button {
  //     width: 100%;
  //     height: 43px;
  //     //border-radius: 24px;
  //     background-color: #000;
  //     color: #fff;
  //     border: none;
  //     border-bottom: 3px solid #B08F6F;
  //     // background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 1));
  //   }
  // }
  img {
    width: calc(41 / 375 * 100vw);
    height: calc(59 / 375 * 100vw);
  }
}
.my-form-box {
    width: 100%;
    //
    display: flex;
    align-items: flex-end;
    position: fixed;
    bottom: 0;
    border-radius: 10px 10px 0px 0px;
    z-index: 999;

    .form-container {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: #fff;
      transition: transform 0.5s;
    }

    .slide-up {
      transform: translateY(390px);
    }

    // padding: 10px 16px 0;
  }

  // 音频播放按钮
  .music-btn {
    z-index: 100;
    @media (max-width:767px) {
      width: calc(33 / 375 * 100vw);
      height: calc(33 / 375 * 100vw);
      position: fixed;
      top: calc(133 / 375 * 100vw);
      right: calc(10 / 375 * 100vw);
    }
    @media (min-width:767px) {
      width: calc(59 / 2200 * 100vw);
      height: calc(59 / 2200 * 100vw);
      position: fixed;
      top: calc(193 / 2200 * 100vw);
      right: calc(50 / 2200 * 100vw);
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover
    }
  }

  /* ==================== 移动端独立样式 ==================== */
  @media (max-width: 767px) {
    .mob-container {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100vw;
      height: 100dvh;
      z-index: 1000;
      overflow: hidden;
    }

    .mob-chatbot-wrapper {
      width: 100%;
      height: 100%;
      position: relative;
    }
  }
</style>
